/**
 * #######################
 *  Usefull Functions
 * #######################
 */

/**
 * Generate Google Calendar event link
 * 
 * @param {string} title The event title
 * @param {string} desc The event description
 * @param {string} locat The event location
 * @param {string} start The start datye.
 * @param {string} end The end date
 */
export function getCalendarEvent(title, desc, locat, start, end) {
    let uri = 'https://www.google.com/calendar/event';

    if (!start || !end) return;

    let startDate = new Date(start);
    startDate.setHours(startDate.getHours() + 3); // fuso horario

    if (!startDate) return;

    let begin = startDate.toISOString().replace(/[-:.]+/g, '');

    let endDate = new Date(end);
    endDate.setHours(endDate.getHours() + 3); // fuso horario

    if (!endDate) return;

    let finish = endDate.toISOString().replace(/[-:.]+/g, '');

    let data = {
        action: 'TEMPLATE',
        text: encodeURIComponent(title),
        details: encodeURIComponent(desc),
        location: encodeURIComponent(locat),
        dates: encodeURIComponent(begin + '/' + finish)
    };

    uri += '?action=' + data.action + '&text=' + data.text + '&details=' + data.details + '&location=' + data.location + '&dates=' + data.dates;

    return uri;
}

/**
 * Encodes Objects into URL parameters
 * 
 * @param {Object|Array} data Object to encode
 * @returns {String} Encoded object to string.
 */
function objectToURL(data) {
    var encodedPairs = [];
    var name = "";

    for (let name in data) {
        encodedPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
    }

    return encodedPairs.join('&').replace(/%20/g, '+');
}
/**
 * 
 * @param {String} method POST, GET, etc.
 * @param {String} url Request URL
 * @param {Array} body Object to send.
 * @param {String} callback Callback function that sends an XMLHttpRequest response object.
 */
export function request(method, url, body, callback) {
    body = objectToURL(body);
    fetch(url, {
        method: method,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: body
    }).then(resBody => resBody.text().then(callback).catch(err => console.error(err))
    ).catch(err => console.error('Fetch Error', err));
}

/**
 * 
 * @param {String} method POST, GET, etc.
 * @param {String} url Request URL
 * @param {Array} body Object to send.
 * 
 * @returns {Promise<Response>}
 */
export function wpFetch(method, url, body) {
    body = objectToURL(body);
    return fetch(url, {
        method: method,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: body
    });
}